import { api } from '../index';
import { TAxiosResponse } from '../baseApiTypes';
import {
  IForgotPasswordModel,
  ILoginModel,
  ILoginResponse,
  ILoginViaGoogleModel,
  ILoginViaLinkedInModel,
  IRecoveryPassword,
  IRegisterAsExpert1Model,
  IRegisterAsExpert2Model,
  IRegisterAsJournalistModel,
  TAreasResponse,
  TAvailableForAppearancesIn,
  TMediumsResponse,
} from './types';

export const login = (form: ILoginModel): TAxiosResponse<ILoginResponse> =>
  api.post('/auth/login', form);

export const loginViaGoogle = (
  data: ILoginViaGoogleModel,
): TAxiosResponse<any> =>
  api.post(`/journalist/social-auth/google/${data.token}/${localStorage.getItem('userType')}`, data);

  export const loginExpertPart = (
    data: IRegisterAsExpert1Model,
  ): TAxiosResponse<any> =>
    api.post(`/expert/social-auth/updation`, data);
  

export const loginViaLinkedIn = (
  data: ILoginViaLinkedInModel,
): TAxiosResponse<any> =>
  api.post(`/journalist/social-auth/linkedin/${data.token}/${localStorage.getItem('userType')}`, data);

export const registerAsExpert1 = (
  data: IRegisterAsExpert1Model,
): TAxiosResponse<any> => api.post('/auth/registration-expert', data);

export const registerAsExpert2 = (
  data: IRegisterAsExpert2Model,
): TAxiosResponse<any> => api.post('/auth/registration-expert-step2', data);

export const registerAsJournalist = (
  data: IRegisterAsJournalistModel,
): TAxiosResponse<ILoginResponse> =>
  api.post('/auth/registration-journalist', data);

export const getProfile = (): TAxiosResponse<any> => api.get('profile');

export const getMediums = (): TAxiosResponse<TMediumsResponse> =>
  api.get('mediums');

export const getAreas = (): TAxiosResponse<TAreasResponse> => api.get('areas');

export const getAvailableForAppearancesIn =
  (): TAxiosResponse<TAvailableForAppearancesIn> => api.get('/available');

export const forgotPassword = (
  data: IForgotPasswordModel,
): TAxiosResponse<any> => api.post('password/create', data);

export const recoveryPassword = (
  data: IRecoveryPassword,
): TAxiosResponse<any> => api.post('password/reset', data);

export const AuthApi = {
  getProfile,
  login,
  loginViaGoogle,
  loginViaLinkedIn,
  registerAsExpert1,
  registerAsExpert2,
  registerAsJournalist,
  getMediums,
  getAvailableForAppearancesIn,
  forgotPassword,
  recoveryPassword,
  getAreas,
  loginExpertPart
};
